import './legal.css'

import {FC} from 'react'

import {legalStrings} from '../../legal/legal-helpers'
import {LegalInline} from './legal-inline'
import {useLegalLang} from './use-legal-lang'

/** "By creating an account or signing in you agree to ..." under every step of the sign-in / sign-up modal. */
export const AuthAgreement: FC = () => {
  const lang = useLegalLang()
  return (
    <p
      className='legal-agree'
      data-testid='auth-agreement'
      lang={lang}
    >
      <LegalInline
        text={legalStrings(lang).signUpAgree}
        newTab
      />
    </p>
  )
}
